module.exports = __webpack_public_path__ + "static/media/account_menu_icon.941ee6a1.svg";